import { registerSW } from 'virtual:pwa-register';

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    // Register the service worker with VitePWA
    const updateSW = registerSW({
      // When new content is available, prompt the user to refresh
      onNeedRefresh() {
        if (confirm('New content available. Reload to update?')) {
          updateSW(true);
        }
      },
      // When the app is ready to work offline
      onOfflineReady() {
        console.log('App ready to work offline');
      },
      // When the service worker is registered successfully
      onRegistered(registration) {
        console.log('Service worker has been registered', registration);
      },
      // When the service worker registration fails
      onRegisterError(error) {
        console.error('Service worker registration error:', error);
      }
    });
    
    console.log('Service worker registration initiated');
    return updateSW;
  }
  
  return () => {};
}